import { render } from "./AboutContent.vue?vue&type=template&id=912d8be0"
import script from "./AboutContent.vue?vue&type=script&lang=js"
export * from "./AboutContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__